// removed by extract-text-webpack-plugin
module.exports = {"select":"_2IBYQYCRr2c35Fvbu4Trqz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/categoryTags.less
// module id = 114
// module chunks = 0